<template>
    <v-text-field 
        :label="label" 
        :value="getValueCurrencyFormat" 
        prefix="Rp" 
        placeholder="0"
        :outlined="outlined"
        :readonly="readonly" 
        :rules="rules" 
        @input="$emit('input', updateValue($event))"
        @blur="$emit('blur')"
    />
</template>


<script>


export default {
    model: {
        prop: "value"
    },

    props: {
        value: {
            type: Number,
            default: 0
        },
        label: {
            type: String,
            default: ""
        },
        outlined: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        rules: {
            type: Array,
            required: false
        }
    },

    computed: {
        getValueCurrencyFormat() {
            return '' + this.value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
        },
    },

    methods: {
        updateValue(v) {
            if (v) {
                return Number(v.replace(/[^0-9,]/g, ''));
            }

            return 0;
        }
    },
}

</script>
